<template>
  <div>
    <div class="top">
      <div class="plan" @click="cancel">广告计划</div>
      <div>></div>
      <div class="new">新建广告计划</div>
    </div>
    <div class="create-plan">
      <el-form label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="推广目的">
          <el-radio-group v-model="form.purpose">
            <el-radio-button label="0">线索收集</el-radio-button>
            <el-radio-button label="1">应用推广</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="广告计划名称" prop="title">
          <el-input v-model="form.title" style="width: 320px;" placeholder="请输入广告计划名称"></el-input>
        </el-form-item>
        <el-form-item label="投放预算" prop="budget">
          <el-input v-model="form.budget" style="width: 320px;" placeholder="请输入投放预算"></el-input>
          <!-- <span style="margin-left: 10px;">元不填写预算代表预算不限</span> -->
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="submitForm('form', 'cancel')">保存并关闭</el-button>
          <!-- <el-button type="primary" @click="submitForm('form', 'next')">保存并创建单元</el-button> -->
          <el-button @click="cancel">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>

</template>

<script>
export default {
  name: 'createPlan',
  props: ['plan_data'],
  data() {
    return {
      form: {
        plan_id: '',
        purpose: '0',
        title: '',
        budget: ''
      },
      type: 'add',
      rules: {
        title: [
          { required: true, message: '请输入推广计划', trigger: 'blur' },
          { min: 0, max: 30, message: '长度不能超过30个字符', trigger: 'blur' }
        ],
        budget: [
          { required: true, message: '请输入投放预算', trigger: 'blur' }
        ],
        purpose: [
          { required: true, message: '请选择目的', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    // 编辑
    if (this.plan_data.plan_id !== undefined && parseInt(this.plan_data.plan_id) > 0) {
      this.form = {
        plan_id: this.plan_data.plan_id,
        purpose: this.plan_data.purpose + '',
        title: this.plan_data.title,
        budget: this.plan_data.budget_v
      };
      this.type = 'edit';
    }
    this.$function.hiddenLoading();
  },
  methods: {
    submitForm(formName, make) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.type === 'add' ? '/trader/index/createPlan' : '/trader/index/savePlan';
          this.$http.post(url, this.form).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('plan_call_back', make);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.$emit('plan_call_back', 'cancel');
    }
  }
};
</script>

<style lang="less" scoped="">
  .create-plan {
    background: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    border-radius: 4px;
    padding: 30px 20px 20px;
  }
  .top {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    height: 64px;
    font-size: 14px;
    color: #606266;
    background: #fff;
    padding: 0 25px;
    div {
      margin-right: 5px;
    }
    .plan:hover {
      cursor: pointer;
      color: #1890FF;
    }
  }
</style>
